import { Injector, Type } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { DatasourceTableGitService } from './datasource-table-git.service';

export abstract class DatasourceTableGitFactoryService<
  T extends DatasourceTableGitService = DatasourceTableGitService,
> extends AbstractGitFactoryService<T> {
  constructor(protected readonly cfg: { injector: Injector; gitService: Type<T> }) {
    super(cfg);
  }
}
